export default {

    card: {
        background: "#FFFFFF",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        padding: "15px"
    },

    radioInput: {
        alignItems: "flex-end",
        columnGap: "15px"
    }
}